import { SxProps, Tab, Tabs } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { FC } from 'react';

interface ITabsCustomized {
  value: number;
  handleChange: any;
  tabList: string[] | React.ReactNode[];
  tabClassname?: string;
  sx?: SxProps;
}

const useStyles = makeStyles(
  {
    tabs: {
      '& .MuiTabs-indicator': {
        backgroundColor: '#009CE0',
      },
      '& .MuiTab-root.Mui-selected': {
        color: '#009CE0',
      },
    },
  },
  {
    name: 'Mui_Component',
  }
);

const TabsCustomized: FC<ITabsCustomized> = ({
  value,
  handleChange,
  tabList,
  tabClassname,
  sx,
}) => {
  const classes = useStyles();
  const a11yProps = (index: number) => {
    return {
      id: `customized-tab-${index}`,
      'aria-controls': `customized-tabpanel-${index}`,
    };
  };

  const renderTab = () => {
    return tabList.map((tab, index) => (
      <Tab
        key={index}
        label={tab}
        sx={{
          textTransform: 'none',
          fontSize: '14px',
          fontWeight: 500,
          padding: '9px 16px',
          // width: tabWidth,
        }}
        className={tabClassname ?? ''}
        {...a11yProps(index)}
      />
    ));
  };
  return (
    <>
      <Tabs
        value={value}
        onChange={handleChange}
        aria-label="customized-space-tabs"
        className={classes.tabs}
        indicatorColor="primary"
        variant="scrollable"
        sx={sx}
      >
        {renderTab()}
      </Tabs>
    </>
  );
};
export default TabsCustomized;
